const baseModule = (module, view = false, actions = {}, special_actions = {}) => ({
  module,
  view,
  actions,
  special_actions,
});

const leadsConfig = [
  baseModule('leads', true, { create: true, update: true }, { export: true }),
  baseModule('prospectos', false, {}, { export: false }),
  baseModule('chats', true, {}, { export: true, human_atention: true, export_chat: true, delete_chat: true, can_block_contact: false, create_chat: true, filters: true }),
  baseModule('horarios de atención', true, { update: true }),
  baseModule('contactos', true, { create: true, update: true, delete: true }, { export: true }),
  baseModule('productos', true, { create: true, status: true, update: true, delete: true }, { export: true }),
  baseModule('perfiles', false, { create: false, status: false, update: false, delete: false }, { export: false, link_documents_rh: false }),
  baseModule('aprendizaje', false, { create: false, delete: false }),
  baseModule('dashboard leads', true, { create: false, update: false }, { export: false }),
];

const rrhhConfig = [
  baseModule('leads', false, { create: false, update: false }, { export: false }),
  baseModule('prospectos', true, {}, { export: true }),
  baseModule('chats', true, {}, { export: true, human_atention: true, export_chat: true, delete_chat: true, can_block_contact: false, create_chat: true, filters: true }),
  baseModule('horarios de atención', true, { update: true }),
  baseModule('contactos', true, { create: true, update: true, delete: true }, { export: true }),
  baseModule('productos', false, { create: false, status: false, update: false, delete: false }, { export: false }),
  baseModule('perfiles', true, { create: true, status: true, update: true, delete: true }, { export: true, link_documents_rh: true }),
  baseModule('aprendizaje', false, { create: false, delete: false }),
];

const conersationalConfig = [
  baseModule('leads', false, { create: false, update: false }, { export: false }),
  baseModule('prospectos', false, {}, { export: false }),
  baseModule('chats', true, {}, { export: true, human_atention: true, export_chat: true, delete_chat: true, can_block_contact: false, create_chat: true, filters: true }),
  baseModule('horarios de atención', true, { update: true }),
  baseModule('contactos', true, { create: true, update: true, delete: true }, { export: true }),
  baseModule('productos', false, { create: false, status: false, update: false, delete: false }, { export: false }),
  baseModule('perfiles', false, { create: false, status: false, update: false, delete: false }, { export: false, link_documents_rh: false }),
  baseModule('aprendizaje', false, { create: false, delete: false }),
];

const supportConfig = [
  baseModule('leads', false, { create: false, update: false }, { export: false }),
  baseModule('chats', true, {}, { export: true, human_atention: true, export_chat: true, delete_chat: true, create_chat: true, filters: true }),
  baseModule('horarios de atención', true, { update: true }),
  baseModule('aprendizaje', false, { create: false, delete: false }),
  baseModule('tickets', true, { create: true, update: true, delete: true }, { export: true }),
];

const defaultConfig = [
  baseModule('leads', false, { create: false, update: false }, { export: false }),
  baseModule('prospectos', false, {}, { export: false }),
  baseModule('chats', false, {}, { export: false, human_atention: false, export_chat: false, delete_chat: false, can_block_contact: false, create_chat: false, filters: false }),
  baseModule('horarios de atención', false, { update: false }),
  baseModule('contactos', false, { create: false, update: false, delete: false }, { export: false }),
  baseModule('productos', false, { create: false, status: false, update: false, delete: false }, { export: false }),
  baseModule('perfiles', false, { create: false, status: false, update: false, delete: false }, { export: false, link_documents_rh: false }),
  baseModule('aprendizaje', false, { create: false, delete: false }),
];

export const getModuleConfigById = (id) => {
  console.log(id);
  switch (id) {
    case 1:
      return leadsConfig;
    case 2:
    case 3:
      return rrhhConfig;
    case 4:
      return conersationalConfig;
    case 5:
      return supportConfig;
    default:
      return defaultConfig;
  }
};
